import { EcoBreakdown } from '@/dto/scenario/eco/EcoBreakdown';
import { EcoCapexExt } from '@/classes/scenario/eco/EcoCapexExt';

export class EcoBreakdownExt extends EcoCapexExt {
  public static fromDto(dto: EcoBreakdown): EcoBreakdownExt {
    return new EcoBreakdownExt({
      pvModule: dto.pvModule,
      pvRackSystem: dto.pvRackSystem,
      pvInverter: dto.pvInverter,
      pvInverterAcdcRatio: dto.pvInverterAcdcRatio,
      pvLogisticAndTransport: dto.pvLogisticAndTransport,
      otherAntiInjectionDevice: dto.otherAntiInjectionDevice,
      otherAcBillOfService: dto.otherAcBillOfService,
      otherDcBillOfService: dto.otherDcBillOfService,
      otherLogisticAndTransport: dto.otherLogisticAndTransport,
      pvStructureCivilWorks: dto.pvStructureCivilWorks,
      pvStructureShelter: dto.pvStructureShelter,
      projectInstallationPriceFixed: dto.projectInstallationPriceFixed,
      pvMechanicalInstallation: dto.pvMechanicalInstallation,
      pvElectricalInstallation: dto.pvElectricalInstallation,
      projectAffiliatesAndHq: dto.projectAffiliatesAndHq,
      projectEngineeringAndAdministrative: dto.projectEngineeringAndAdministrative,
      projectEpcMargin: dto.projectEpcMargin,
      projectSupervision: dto.projectSupervision,
      generatorBeforeDayCost: dto.generatorBeforeDayCost,
      generatorBeforeNightCost: dto.generatorBeforeNightCost,
      generatorBeforeLogisticAndTransport: dto.generatorBeforeLogisticAndTransport,
      generatorAfterDayCost: dto.generatorAfterDayCost,
      generatorAfterNightCost: dto.generatorAfterNightCost,
      generatorAfterLogisticAndTransport: dto.generatorAfterLogisticAndTransport,
      batteryModule: dto.batteryModule,
      batteryPriceReduction: dto.batteryPriceReduction,
      batteryInverter: dto.batteryInverter,
      batteryLogisticAndTransport: dto.batteryLogisticAndTransport,
      batteryStructureCivilWorks: dto.batteryStructureCivilWorks,
      batteryStructureShelter: dto.batteryStructureShelter,
      batteryMechanicalInstallation: dto.batteryMechanicalInstallation,
      batteryElectricalInstallation: dto.batteryElectricalInstallation,
      generatorCostType1: dto.generatorCostType1,
      generatorCostType2: dto.generatorCostType2,
      generatorLogisticAndTransport: dto.generatorLogisticAndTransport
    } as EcoBreakdownExt);
  }

  public toDto(): EcoBreakdown {
    return new EcoBreakdown({
      pvModule: this.pvModule,
      pvRackSystem: this.pvRackSystem,
      pvInverter: this.pvInverter,
      pvInverterAcdcRatio: this.pvInverterAcdcRatio,
      pvLogisticAndTransport: this.pvLogisticAndTransport,
      otherAntiInjectionDevice: this.otherAntiInjectionDevice,
      otherAcBillOfService: this.otherAcBillOfService,
      otherDcBillOfService: this.otherDcBillOfService,
      otherLogisticAndTransport: this.otherLogisticAndTransport,
      pvStructureCivilWorks: this.pvStructureCivilWorks,
      pvStructureShelter: this.pvStructureShelter,
      projectInstallationPriceFixed: this.projectInstallationPriceFixed,
      pvMechanicalInstallation: this.pvMechanicalInstallation,
      pvElectricalInstallation: this.pvElectricalInstallation,
      projectAffiliatesAndHq: this.projectAffiliatesAndHq,
      projectEngineeringAndAdministrative: this.projectEngineeringAndAdministrative,
      projectEpcMargin: this.projectEpcMargin,
      projectSupervision: this.projectSupervision,
      generatorBeforeDayCost: this.generatorBeforeDayCost,
      generatorBeforeNightCost: this.generatorBeforeNightCost,
      generatorBeforeLogisticAndTransport: this.generatorBeforeLogisticAndTransport,
      generatorAfterDayCost: this.generatorAfterDayCost,
      generatorAfterNightCost: this.generatorAfterNightCost,
      generatorAfterLogisticAndTransport: this.generatorAfterLogisticAndTransport,
      batteryModule: this.batteryModule,
      batteryPriceReduction: this.batteryPriceReduction,
      batteryInverter: this.batteryInverter,
      batteryLogisticAndTransport: this.batteryLogisticAndTransport,
      batteryStructureCivilWorks: this.batteryStructureCivilWorks,
      batteryStructureShelter: this.batteryStructureShelter,
      batteryMechanicalInstallation: this.batteryMechanicalInstallation,
      batteryElectricalInstallation: this.batteryElectricalInstallation,
      generatorCostType1: this.generatorCostType1,
      generatorCostType2: this.generatorCostType2,
      generatorLogisticAndTransport: this.generatorLogisticAndTransport
    });
  }
}
